// pingo-variant-prefetch.js  (§3.22 / G20) — by Studio Lab
//
// Warms the browser HTTP cache for every unselected variant URL on a PDP so the
// first variant swap (default → X) feels the same speed as subsequent swaps.
// Without this, the first click pays the full cold section-render round-trip
// while later clicks hit the warm cache.
//
// Mirrors variant-picker.js buildRequestUrl for the plain-PDP case:
// `${productUrl}?option_values=ID1,ID2,...` — same URL Shopify returns on a
// real variant click, so the prefetched response lives in HTTP cache under
// the exact key the later fetch will look up.
//
// Cost controls: product-page only, saveData off, not 2g/slow-2g, 1.5s idle
// delay, one fetch at a time with 100ms gaps, aborted on pagehide.

(function () {
  const picker = document.querySelector('variant-picker');
  if (!picker) return;

  const conn = /** @type {any} */ (navigator).connection;
  if (conn?.saveData) return;
  if (conn?.effectiveType === '2g' || conn?.effectiveType === 'slow-2g') return;

  const productUrl = picker.dataset.productUrl?.split('?')[0];
  if (!productUrl) return;

  const fieldsets = picker.querySelectorAll('fieldset');
  if (!fieldsets.length) return;

  const currentSelected = [];
  fieldsets.forEach((fs) => {
    const checked =
      fs.querySelector('input[data-current-checked="true"]') ||
      fs.querySelector('input:checked');
    currentSelected.push(checked?.dataset.optionValueId || '');
  });

  const urls = new Set();
  fieldsets.forEach((fs, idx) => {
    fs.querySelectorAll('input').forEach((radio) => {
      if (radio.dataset.currentChecked === 'true') return;
      const id = radio.dataset.optionValueId;
      if (!id) return;
      // Combined-listing variants navigate to a different product URL and go
      // through a full `main` morph — too expensive to prefetch speculatively
      // and the URL shape differs, so skip them.
      if (radio.dataset.connectedProductUrl) return;
      const combo = currentSelected.slice();
      combo[idx] = id;
      const values = combo.filter(Boolean).join(',');
      if (!values) return;
      urls.add(`${productUrl}?option_values=${values}`);
    });
  });

  if (!urls.size) return;

  const queue = Array.from(urls);
  const controller = new AbortController();
  window.addEventListener('pagehide', () => controller.abort(), { once: true });

  const idle =
    typeof window.requestIdleCallback === 'function'
      ? window.requestIdleCallback
      : (cb) => setTimeout(cb, 1);

  idle(
    () => {
      setTimeout(() => {
        if (controller.signal.aborted) return;
        drain();
      }, 1500);
    },
    { timeout: 3000 }
  );

  function drain() {
    if (controller.signal.aborted) return;
    const url = queue.shift();
    if (!url) return;
    fetch(url, {
      signal: controller.signal,
      priority: 'low',
      credentials: 'same-origin',
    })
      .catch(() => {})
      .finally(() => {
        if (controller.signal.aborted) return;
        setTimeout(drain, 100);
      });
  }
})();
